export default __webpack_public_path__ + "images/SKYPASADA.31687f1.png";